import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qpb3ygknfs: FaireBrandEntity = {
  token: "b_qpb3ygknfs",
  type: "brand",
  name: "Divine Vessels Pottery",
  avatarUrl:
    "https://cdn.faire.com/fastly/f75e7ed0f1d4d94eb4fe8f9fdf31ffcbdac46a63bd35dc1739470b4b29080314.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4ce8bfe3ae8cb016eafb6ff6c5087be332ff41eca19439ee735c112fc4f8d591.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f75e7ed0f1d4d94eb4fe8f9fdf31ffcbdac46a63bd35dc1739470b4b29080314.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4ce8bfe3ae8cb016eafb6ff6c5087be332ff41eca19439ee735c112fc4f8d591.png",
  location: "TRUXTON, NY, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "Products are 3 weeks lead-time unless items are in stock.  Divine Vessels Pottery embodies the art of transforming clay into vessels that reflect the sacred nature within us. Each piece is thoughtfully crafted to create a tactile, beautiful experience that elevates everyday moments, inviting mindfulness and appreciation with every use. This collection honors the connection between form and function, offering expert craftsmanship that enhances your daily rituals. ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:54.512Z",
    importedBy: "entity-db-cli",
  },
};
